import "./FsnbRibbonFilters.css";

import { useSelector } from "react-redux";

import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import ArrowDropUpOutlinedIcon from "@mui/icons-material/ArrowDropUpOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";

import CheckBoxFlat from "components/CheckBoxFlat";
import { useLocalStorage } from "hooks/useLocalStorage";
import { getFsnbCcpApprovalPeriods } from "slices/fsnb";

const FsnbRibbonFilters = ({
	fsnbVersArr,
	selectedFsnbVers,
	setSelectedFsnbVers,
	attrsOpts,
	selectedSearchOptions,
	setSelectedSearchOptions,
	inputSearchValue,
	fetchStatus,
	setInputSearchValue,
	moveNextSearch,
	searchFounds,
	searchFoundIndex,
	tabValue,
	superSearchView,
	setFilterTrigger,
	setCurSearchRow,
	selectedCcpApprovalPeriod,
	setSelectedCcpApprovalPeriod,
	ccpResourceType,
	setCcpResourceType,
}) => {
	const isCcpTab = tabValue === "ccp";
	const navigateFromEditor = useSelector((state) => state.ribbon.navigateFromEditor);
	const ccpApprovalPeriods = useSelector(getFsnbCcpApprovalPeriods);

	const { setLsItem } = useLocalStorage();

	const triggerSearch = () => setFilterTrigger((prev) => prev + 1);

	let searchResult = "";
	if (searchFounds?.length > 1) {
		if (searchFounds.length >= 1000) {
			searchResult = `Найдено: ${searchFoundIndex} / более ${searchFounds.length}`;
		} else {
			searchResult = `Найдено: ${searchFoundIndex} / ${searchFounds.length}`;
		}
	}

	let fsnbVersSelectLabel = "Редакция ФСНБ";
	if (tabValue === "nrsp") {
		fsnbVersSelectLabel = "Номера приказов и период действия";
	}

	return (
		<div className="fsnbCustomFilterGroup">
			<div className="fsnbCustomFilterGroupTop">
				{isCcpTab ? (
					<Autocomplete
						disableClearable
						size="small"
						noOptionsText="нет данных"
						options={ccpApprovalPeriods}
						getOptionLabel={(option) => option?.name ?? ""}
						isOptionEqualToValue={(option, value) => option.id === value.id}
						value={selectedCcpApprovalPeriod}
						onChange={(_, newValue) => {
							setSelectedCcpApprovalPeriod(newValue);
						}}
						renderInput={(params) => <TextField {...params} InputLabelProps={{ shrink: true }} label="Период утверждения" />}
						sx={{
							width: "490px",
							"& legend": { fontSize: "9px" },
						}}
					/>
				) : (
					<Autocomplete
						sx={{ width: "490px", "& legend": { fontSize: "9px" } }}
						options={fsnbVersArr}
						value={selectedFsnbVers}
						disableClearable
						disabled={navigateFromEditor === "add" || navigateFromEditor === "abs" || tabValue === "ksr"}
						getOptionLabel={(option) => option.name}
						size="small"
						noOptionsText="нет данных"
						onInputChange={(e, val) => {
							const inpVal = fsnbVersArr.find((x) => x["name"] === val);
							if (inpVal != null) {
								setCurSearchRow({});
								setSelectedFsnbVers(inpVal);
								if (!["nrsp", "ksr"].includes(tabValue)) {
									setLsItem({ key: "selectedFsnbVersId", value: inpVal?.id });
								}
							}
						}}
						renderInput={(params) => <TextField {...params} InputLabelProps={{ shrink: true }} label={fsnbVersSelectLabel} />}
					/>
				)}

				<CheckBoxFlat
					boxWidth={480}
					label="Настройки поиска"
					optionValues={attrsOpts}
					curSelected={selectedSearchOptions}
					f_setCurSelected={setSelectedSearchOptions}
					f_closeAction={triggerSearch}
					disabled={superSearchView || isCcpTab}
				/>
			</div>

			<div className="fsnbCustomFilterGroupBottomWrapper">
				<div className="fsnbCustomFilterGroupBottom">
					<TextField
						sx={{
							width: "490px",
							"& legend": {
								fontSize: "9px",
							},
						}}
						label="Поиск"
						size="small"
						value={inputSearchValue}
						onChange={(e) => {
							if (fetchStatus !== "loading") {
								setInputSearchValue((prev) => e.target.value);
								triggerSearch();
							}
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								if (fetchStatus !== "loading") {
									setInputSearchValue((prev) => e.target.value);
									triggerSearch();
								}
							}
						}}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<SearchIcon fontSize="16px" />
								</InputAdornment>
							),
						}}
						// disabled={isCcpTab}
					/>

					{searchFounds?.length > 1 && (
						<div className="SearchNavButtons">
							<ArrowDropDownOutlinedIcon onClick={(e) => moveNextSearch("next")} />
							<ArrowDropUpOutlinedIcon onClick={(e) => moveNextSearch("prev")} />
						</div>
					)}

					<div className="SearchResults">{searchResult}</div>
					<div className="fsnbCustomFilterGroupRadio"></div>
				</div>
				{isCcpTab && (
					<div className="fsnbCustomFilterGroupRadio">
						<FormControl sx={{ height: "auto !important" }}>
							<RadioGroup
								row
								value={ccpResourceType}
								onChange={(e) => setCcpResourceType(e.target.value)}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 13,
									},
								}}
							>
								<FormControlLabel value="mat" control={<Radio size="small" />} label="Материалы" />
								<FormControlLabel value="eqp" control={<Radio size="small" />} label="Оборудование" sx={{ marginRight: "6px" }} />
							</RadioGroup>
						</FormControl>
					</div>
				)}
			</div>
		</div>
	);
};

export { FsnbRibbonFilters };
